import { useNavigate } from "react-router-dom";
import { ROUTES, withPeek } from "@/app/routes";
import { CreateBeneficiaryWizardModal } from "@/presentation/pages/beneficiaries/modals/CreateBeneficiaryWizardModal";
import { CreateInvestorWizardModal } from "@/presentation/pages/investors/modals/CreateInvestorWizardModal";
import { useShellCreateStore } from "@/stores/useShellCreateStore";

export function ShellCreateModals() {
  const navigate = useNavigate();
  const dialog = useShellCreateStore((state) => state.dialog);
  const handleOpen = useShellCreateStore((state) => state.open);
  const handleClose = useShellCreateStore((state) => state.close);
  return (
    <>
      <CreateBeneficiaryWizardModal
        open={dialog === "beneficiary"}
        onOpenChange={(next) => (next ? handleOpen("beneficiary") : handleClose())}
        onCreated={(beneficiary) => navigate(withPeek(ROUTES.BENEFICIARIES.LIST, beneficiary.uuid))}
      />
      <CreateInvestorWizardModal
        open={dialog === "investor"}
        onOpenChange={(next) => (next ? handleOpen("investor") : handleClose())}
        onCreated={(investor) => navigate(withPeek(ROUTES.INVESTMENTS.INVESTORS, investor.uuid))}
      />
    </>
  );
}
